/**
 * Liste **fermée** des endpoints Overpass — EF-POI-009.
 *
 * Aucune saisie libre d'adresse n'est proposée : une adresse mal saisie
 * priverait l'utilisateur de recherche au moment où il en a besoin, et
 * exposerait ses coordonnées de parcours à un hôte arbitraire.
 *
 * Enrichir cette liste exige une nouvelle version de l'application.
 */

export type EndpointId = 'fossgis' | 'vkmaps';

export interface OverpassEndpoint {
  readonly id: EndpointId;
  readonly url: string;
  readonly operator: string;
  readonly note: string;
  /** Mention supplémentaire affichée à la sélection, le cas échéant. */
  readonly warning: string | null;
}

export const OVERPASS_ENDPOINTS: readonly OverpassEndpoint[] = [
  {
    id: 'fossgis',
    url: 'https://overpass-api.de/api/interpreter',
    operator: 'FOSSGIS e.V. (Allemagne)',
    note:
      'Endpoint par défaut. Instance de référence du projet. Environ 10 000 requêtes ' +
      'et 1 Go par jour, deux créneaux simultanés.',
    warning: null,
  },
  {
    id: 'vkmaps',
    url: 'https://maps.mail.ru/osm/tools/overpass/api/interpreter',
    operator: 'VK Maps (Russie)',
    note: 'Secours. Aucune limitation de débit annoncée.',
    warning:
      "L'opérateur est un tiers commercial hors Union européenne. Le tracé du parcours " +
      'préparé lui est transmis lors de chaque recherche.',
  },
];

export const DEFAULT_ENDPOINT_ID: EndpointId = 'fossgis';

export function endpointById(id: EndpointId): OverpassEndpoint {
  const found = OVERPASS_ENDPOINTS.find((endpoint) => endpoint.id === id);
  if (found === undefined) throw new Error(`Endpoint inconnu : ${id}`);
  return found;
}

export function isEndpointId(value: unknown): value is EndpointId {
  return typeof value === 'string' && OVERPASS_ENDPOINTS.some((endpoint) => endpoint.id === value);
}
